import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { FlatCardText1, FlatCardText2, FlatCardTextEm, FlatCards } from "../../../../Constant";
import { FLAT_CARD } from "../../../../Data/Bonus Ui/BasicCard";
import { P } from "../../../../AbstractElements";

const FlatCard = () => {
  return (
    <Col sm="12" xl="6">
      <Card className="b-r-0">
        <CommonCardHeader title={FlatCards} span={FLAT_CARD} headerClass={true}/>
        <CardBody>
          <P className="mb-0">
            {FlatCardText1}<em className="txt-danger">{FlatCardTextEm}</em>{FlatCardText2}
          </P>
        </CardBody>
      </Card>
    </Col>
  );
};

export default FlatCard;